import { AgentsBoxCard } from '@motorway/motorway-handshake-components';

import { Header } from '../../components/Header/Header';
import { MessagingList, MESSAGING_LIST_FORMATTERS } from '../../components/MessagingList/MessagingList';
import { SignOut } from '../../components/SignOut/SignOut';
import { VehicleCard } from '../../components/VehicleCard/VehicleCard';
import { snowplowCtaClick } from '../../helpers/snowplow';

import styles from './Complete.module.scss';

export const Complete = () => (
  <div className={styles.component}>
    <Header>
      <h1>Payment can now be made to the seller</h1>
      <SignOut />
    </Header>
    <MessagingList
      formatter={MESSAGING_LIST_FORMATTERS.CALCULATE_FINAL_INVOICE}
      highlightRow={1}
      motorwayPay
    />
    <AgentsBoxCard clickCallback={snowplowCtaClick} />
    <VehicleCard />
  </div>
);
